/*
  Vergelijken vanaf collectie- en zoekpagina's (Harun, 26-09-2026: "wanneer ik naar accubooster ga en ik klik op
  2 producten om te vergelijken komt de oude tevoorschijn"). Alleen actief als snippets/astools-vergelijk-lijst.liquid
  op de pagina staat (collectie- en zoekpagina's met vergelijken aan).

  - Het vinkje Vergelijken staat alleen bij producten met vergelijkdata (snippets/product-card.liquid) en draagt de
    vergelijkcollecties van het product mee (data-ap-vg-collecties). De lade van het thema (compare-drawer.js)
    houdt de keuze bij in localStorage (cc-compare-products: [{ id, url }], hooguit compare_max).
  - "Als 1 collectie niet overeenkomt is vergelijken niet mogelijk": vinkt de klant een product aan dat geen
    collectie deelt met wat al gekozen is, dan vangen we de change af (capture-fase op window, dus voor de lade),
    gaat het vinkje weer uit en komt er een korte melding.
  - Daarvoor kennen we van elk gekozen product de collecties ("kaart", localStorage ap-vg:kaarten, een dag
    geldig): van het vinkje op de pagina, en anders opgehaald via <product-url>?section_id=astools-vergelijk-kaart
    (sections/astools-vergelijk-kaart.liquid). Dat ophalen gebeurt bij het laden van de pagina voor gekozen producten
    zonder kaart (gekozen op een andere pagina, of een keuze van voor deze regel) en na Wijzig in het venster
    (dan eerst een voorlopige kaart met de collectie van het venster). Een product dat niet meer bestaat of geen
    vergelijkdata meer heeft, gaat stil uit de keuze.
  - Nu vergelijken: de lade sluit en stuurt on:product-compare-modal:open naar .js-compare-modal. Dat event vangen
    we in de capture-fase op window af en we openen ons eigen venster: <dialog class="ap-vgm"> (modaal: de focus
    blijft erin, Esc, het kruisje en een klik buiten sluiten, de pagina scrolt niet mee) met
    <ap-vergelijker data-modus="vrij">. Het oude venster van het thema (compare-modal.js en
    sections/product-compare.liquid) is sinds 02-10-2026 weg; snippets/product-compare.liquid houdt alleen een leeg,
    verborgen .js-compare-modal over, omdat compare-drawer.js (ongewijzigd) dat nodig heeft.
  - Welke collectie: die de meeste gekozen producten delen (normaal: allemaal), bij gelijke stand die van deze
    pagina. Delen minder dan 2 gekozen producten een collectie (een oude, gemengde keuze), dan gaat het venster
    niet open: de keuze wordt gewist en een melding vraagt om opnieuw te kiezen. Kunnen niet alle gekozen
    producten mee, dan vergelijken we de grootste groep, zeggen dat in het venster en halen de rest uit de keuze.
    Lukt het laden toch niet, dan sluit het venster weer met een korte melding (geen leeg venster).
  - Wijzig en weghalen in het venster passen de keuze van de lade aan (vinkjes en teller ook).
  - Staat er op de pagina geen enkel vinkje (een collectie zonder vergelijkdata), dan verdwijnt de schakelaar
    Vergelijken uit de werkbalk en staan de kaarten zoals met vergelijken uit (zonder die stand te bewaren).
  Zonder <dialog>.showModal (heel oude browsers) kan geen venster meer open: dit blok zet dan alleen de klasse
  ap-vg-uit op <html>, en assets/compare-toggle.css verbergt de schakelaar, de vinkjes, de knop en de lade.
  Laadt dit bestand niet of stopt het eerder (onleesbaar JSON-blok, een fout), dan zet een vangnet in
  snippets/astools-vergelijk-lijst.liquid bij DOMContentLoaded dezelfde klasse: window.apVergelijkVenster (de laatste
  regel hieronder) ontbreekt dan.

  Laden (01-10-2026): dit blok stond onderaan assets/astools-productpagina.js. Op collectie- en zoekpagina's laadt
  alleen dit bestand (snippets/astools-vergelijk-lijst.liquid); het grote bestand met de vergelijker
  (ap-vergelijker) en de meldingen (window.astoolsProductpagina) komt pas bij de eerste aanraking van een
  vergelijkvinkje, de schakelaar of de lade, of na het laden van de pagina als er al een keuze bewaard is. Een
  melding wacht daarop; het venster toont tot dan zijn laadstand. Laadt het niet, dan zegt het venster dat.
*/
(() => {
  const bron = document.getElementById('ap-vg-lijst');
  if (!bron || window.apVergelijkVenster) return;
  // Zonder <dialog> kan ons venster niet open, en het oude venster van het thema is weg (02-10-2026): dan verdwijnt
  // vergelijken van de pagina (assets/compare-toggle.css verbergt alles onder html.ap-vg-uit).
  if (typeof window.HTMLDialogElement !== 'function' || typeof window.HTMLDialogElement.prototype.showModal !== 'function') {
    document.documentElement.classList.add('ap-vg-uit');
    return;
  }
  let cfg = null;
  try {
    cfg = JSON.parse(bron.textContent);
  } catch (e) {
    return;
  }
  if (!cfg || typeof cfg !== 'object') return;

  const NL = {
    modal_kop: 'Vergelijken',
    sluiten: 'Sluiten',
    andere_categorie: 'Dit product kun je niet vergelijken met je keuze: het zit in een andere categorie.',
    nieuwe_vergelijking: 'Nieuwe vergelijking gestart: je vorige keuze uit een andere categorie is gewist.',
    min_twee: 'Kies minstens 2 producten uit dezelfde categorie om te vergelijken.',
    niet_mee: 'Niet alle gekozen producten zitten in dezelfde categorie. We vergelijken alleen de producten uit de categorie %collectie%.',
    niet_alle: 'Niet alle gekozen producten konden we vergelijken. We vergelijken de producten uit de categorie %collectie%.',
    gemengd: 'Je keuze bevatte producten uit verschillende categorieën. Kies opnieuw 2 producten uit dezelfde categorie.',
    laden: 'Vergelijking laden…',
    laden_mislukt: 'De vergelijking kon niet laden. Probeer het later opnieuw.'
  };
  const SELECTIE = 'cc-compare-products'; // theme.storageUtil in main.js zet cc- voor de sleutel
  const KAARTEN = 'ap-vg:kaarten';
  const MAX_KAARTEN = 60;
  const KAART_MS = 24 * 60 * 60 * 1000;
  const OPHALEN_MS = 4000;
  const SLUIT_ICOON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  const teksten = cfg.teksten && typeof cfg.teksten === 'object' ? cfg.teksten : {};
  // De filter t geeft HTML-veilige tekst; terug naar gewone tekst (een textarea maakt nooit elementen aan).
  const ontsleutel = (s) => {
    if (s.indexOf('&') === -1) return s;
    const el = document.createElement('textarea');
    el.innerHTML = s;
    return el.value;
  };
  const t = (sleutel, vars) => {
    let s = teksten[sleutel];
    if (typeof s !== 'string' || !s.trim() || s.indexOf('ranslation missing') !== -1) s = NL[sleutel] || '';
    else s = ontsleutel(s);
    if (vars) Object.keys(vars).forEach((k) => { s = s.split(`%${k}%`).join(vars[k]); });
    return s;
  };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[c]);
  const wacht = (ms) => new Promise((klaar) => { setTimeout(klaar, ms); });
  const ladeKnop = () => document.getElementById('compare-drawer-open');

  // Het volledige script (assets/astools-productpagina.js): één keer toevoegen; klaar als het geladen is en
  // ap-vergelijker bestaat, mislukt bij een laadfout of na 10 s (dan probeert een volgende aanroep het opnieuw).
  let volledig = null;
  const volledigKlaar = () => Boolean(window.astoolsProductpagina && window.customElements.get('ap-vergelijker'));
  function laadVolledig() {
    if (volledigKlaar()) return Promise.resolve();
    if (volledig) return volledig;
    const url = typeof cfg.volledig === 'string' ? cfg.volledig : '';
    if (!/^(https?:)?\/\//.test(url)) return Promise.reject(new Error('geen url'));
    volledig = new Promise((klaar, mislukt) => {
      const s = document.createElement('script');
      s.src = url;
      s.async = true;
      const timer = setTimeout(() => mislukt(new Error('te traag')), 10000);
      s.addEventListener('load', () => {
        window.customElements.whenDefined('ap-vergelijker').then(() => {
          clearTimeout(timer);
          klaar();
        });
      });
      s.addEventListener('error', () => {
        clearTimeout(timer);
        s.remove();
        mislukt(new Error('laadfout'));
      });
      document.head.appendChild(s);
    });
    volledig.catch(() => {
      if (!volledigKlaar()) volledig = null;
    });
    return volledig;
  }

  const meldKort = (tekst, bronEl) => {
    const toon = () => {
      const api = window.astoolsProductpagina;
      if (api && typeof api.melding === 'function') api.melding(tekst, { info: true, bron: bronEl || null });
    };
    if (window.astoolsProductpagina) toon();
    else laadVolledig().then(toon, () => {});
  };

  /* ---------- Opslag ---------- */

  const lees = (sleutel) => {
    try {
      const ruw = window.localStorage.getItem(sleutel);
      return ruw ? JSON.parse(ruw) : null;
    } catch (e) {
      return null;
    }
  };
  const zet = (sleutel, waarde) => {
    try {
      window.localStorage.setItem(sleutel, JSON.stringify(waarde));
    } catch (e) {
      /* vol of geblokkeerd */
    }
  };

  const geldig = (c) => Boolean(c && typeof c.handle === 'string' && c.handle && typeof c.url === 'string' && /^\/(?!\/)/.test(c.url));
  const netjes = (c) => ({ handle: c.handle, id: c.id != null ? String(c.id) : '', titel: typeof c.titel === 'string' ? c.titel : '', url: c.url });
  const collectieLijst = (l) => (Array.isArray(l) ? l.filter(geldig).map(netjes) : null);

  // De keuze van de lade: [{ id, url }], zonder dubbelen.
  function selectie() {
    const s = lees(SELECTIE);
    if (!Array.isArray(s)) return [];
    const gezien = new Set();
    return s
      .filter((p) => p && p.id != null)
      .map((p) => ({ id: String(p.id), url: typeof p.url === 'string' ? p.url : '' }))
      .filter((p) => {
        if (gezien.has(p.id)) return false;
        gezien.add(p.id);
        return true;
      });
  }

  // Zoals CompareUtil (compare-drawer.js): keuze opslaan, vinkjes en tellers op de pagina bijwerken, en bij een lege
  // keuze de knop Vergelijken van de lade weg (toggleCompareButton). De url zonder zoekparameters (?_pos=...): de
  // lade plakt er zelf ?sections=... achter.
  function zetSelectie(lijst) {
    zet(SELECTIE, lijst.map((p) => ({ id: p.id, url: String(p.url || '').split('?')[0] })));
    const ids = new Set(lijst.map((p) => p.id));
    document.querySelectorAll('.js-compare-checkbox').forEach((cb) => {
      cb.checked = ids.has(String(cb.dataset.productId));
    });
    document.querySelectorAll('.js-compare-counter').forEach((el) => {
      el.textContent = String(lijst.length);
    });
    const knop = ladeKnop();
    if (knop && !lijst.length) knop.classList.add('is-out');
  }

  // Een eerder bewaarde keuze met ?_pos=... in de url (van de zoekpagina) kon de lade niet tonen: opschonen.
  const bewaard = lees(SELECTIE);
  if (Array.isArray(bewaard) && bewaard.some((p) => p && typeof p.url === 'string' && p.url.indexOf('?') !== -1)) {
    zet(SELECTIE, bewaard.map((p) => (p && typeof p.url === 'string' ? Object.assign({}, p, { url: p.url.split('?')[0] }) : p)));
  }

  /* ---------- Kaarten: de vergelijkcollecties van gekozen producten ---------- */

  function kaarten() {
    const k = lees(KAARTEN);
    return k && typeof k === 'object' && !Array.isArray(k) ? k : {};
  }

  // voorlopig: alleen de collectie van het venster (na Wijzig), de volledige kaart wordt nog opgehaald.
  function bewaarKaart(id, collecties, voorlopig) {
    const k = kaarten();
    k[id] = voorlopig ? { c: collecties, t: Date.now(), v: 1 } : { c: collecties, t: Date.now() };
    const ids = Object.keys(k);
    if (ids.length > MAX_KAARTEN) {
      ids.sort((a, b) => (k[a].t || 0) - (k[b].t || 0))
        .slice(0, ids.length - MAX_KAARTEN)
        .forEach((x) => { delete k[x]; });
    }
    zet(KAARTEN, k);
  }

  function vergeetKaarten(ids) {
    const k = kaarten();
    ids.forEach((id) => { delete k[id]; });
    zet(KAARTEN, k);
  }

  // De bewaarde kaart als die nog geldt: { c: [collecties] (leeg: niet te vergelijken), voorlopig }, anders null.
  function kaartVan(id) {
    const k = kaarten()[id];
    if (!k || typeof k.t !== 'number' || Date.now() - k.t > KAART_MS) return null;
    const c = collectieLijst(k.c);
    return c ? { c, voorlopig: k.v === 1 } : null;
  }

  function vinkjeVan(id) {
    try {
      return document.querySelector(`.js-compare-checkbox[data-product-id="${CSS.escape(id)}"][data-ap-vg-collecties]`);
    } catch (e) {
      return null;
    }
  }

  function uitVinkje(cb) {
    try {
      return collectieLijst(JSON.parse(cb.getAttribute('data-ap-vg-collecties') || 'null'));
    } catch (e) {
      return null;
    }
  }

  // De vergelijkcollecties van een product: van het vinkje op deze pagina, anders de kaart. [] is bekend maar niet
  // te vergelijken (verdwenen of zonder vergelijkdata), null is onbekend.
  function collectiesVan(id) {
    const cb = vinkjeVan(id);
    const hier = cb ? uitVinkje(cb) : null;
    if (hier) return hier;
    const k = kaartVan(id);
    return k ? k.c : null;
  }

  // Moet de kaart (nog) worden opgehaald? Niet als het vinkje op deze pagina staat.
  const moetOphalen = (p) => {
    if (vinkjeVan(p.id)) return false;
    const k = kaartVan(p.id);
    return !k || k.voorlopig;
  };

  // De kaart van één product ophalen (sections/astools-vergelijk-kaart.liquid). Geeft de collecties ([] als het
  // product niet meer bestaat of geen vergelijkdata heeft), of null als het niet lukte (dan blijft hij onbekend).
  const bezigMet = new Map();
  function haalKaart(p) {
    if (bezigMet.has(p.id)) return bezigMet.get(p.id);
    const url = String(p.url || '').split('?')[0];
    if (!/^\/(?!\/)/.test(url)) return Promise.resolve(null);
    const belofte = (async () => {
      try {
        const antwoord = await fetch(`${url}?section_id=astools-vergelijk-kaart`, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (antwoord.status === 404) {
          bewaarKaart(p.id, []);
          return [];
        }
        if (!antwoord.ok) return null;
        const html = await antwoord.text();
        const blok = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-ap-vg-kaart]');
        const data = blok ? JSON.parse(blok.textContent) : null;
        if (!data) return null;
        // Geen product op deze url (Shopify geeft dan 200 met id null) of een ander product (doorverwezen): het
        // gekozen product bestaat daar niet meer.
        const lijst = data.id != null && String(data.id) === p.id ? collectieLijst(data.c) || [] : [];
        bewaarKaart(p.id, lijst);
        return lijst;
      } catch (e) {
        return null;
      } finally {
        bezigMet.delete(p.id);
      }
    })();
    bezigMet.set(p.id, belofte);
    return belofte;
  }

  const leerKennen = (sel) => Promise.all(sel.filter(moetOphalen).map(haalKaart));

  // Producten die niet (meer) te vergelijken zijn gaan stil uit de keuze. Geeft het aantal.
  function ruimOp() {
    const sel = selectie();
    const blijft = sel.filter((p) => {
      const c = collectiesVan(p.id);
      return !c || c.length > 0;
    });
    if (blijft.length !== sel.length) zetSelectie(blijft);
    return sel.length - blijft.length;
  }

  /* ---------- Aanvinken: alleen binnen dezelfde collectie ---------- */

  window.addEventListener('change', (e) => {
    const cb = e.target;
    if (!cb || !cb.classList || !cb.classList.contains('js-compare-checkbox') || !cb.checked) return;
    const id = String(cb.dataset.productId || '');
    const eigen = uitVinkje(cb);
    if (!id || !eigen) return;
    let gedeeld = eigen.map((c) => c.handle);
    selectie().forEach((p) => {
      if (p.id === id) return;
      const hun = collectiesVan(p.id);
      // Onbekend (de kaart komt nog) of niet te vergelijken (gaat uit de keuze): telt niet mee.
      if (!hun || !hun.length) return;
      const set = new Set(hun.map((c) => c.handle));
      gedeeld = gedeeld.filter((h) => set.has(h));
    });
    if (!gedeeld.length) {
      // Een product uit een andere categorie dan de bewaarde keuze (27-09-2026, Harun: "het is wel in dezelfde
      // categorie"). De oude keuze lag vaak nog van een andere pagina of een eerder bezoek, en is op de telefoon
      // niet te zien. Zoals bij Coolblue begint er dan een nieuwe vergelijking met dit product: de oude keuze gaat
      // weg, met een korte melding. Het vinkje blijft aan en de change gaat door naar de lade, die dit product aan de
      // (nu lege) keuze toevoegt; de lade leest de keuze telkens uit localStorage.
      zetSelectie([]);
      cb.checked = true;
      bewaarKaart(id, eigen);
      meldKort(t('nieuwe_vergelijking'), cb);
      return;
    }
    bewaarKaart(id, eigen);
  }, true);

  /* ---------- Welke collectie ---------- */

  // Collecties met het aantal gekozen producten dat erin zit, in volgorde van voorkeur: eerst die het meest
  // gedeeld worden (normaal: door allemaal), bij gelijke stand de collectie van deze pagina. De collectie van deze
  // pagina staat er altijd in (desnoods met 0), voor gekozen producten die nog onbekend zijn.
  function telCollecties(sel) {
    const telling = new Map();
    sel.forEach((p) => {
      const lijst = collectiesVan(p.id);
      if (!lijst) return;
      lijst.forEach((c) => {
        const x = telling.get(c.handle);
        if (x) x.n += 1;
        else telling.set(c.handle, { c, n: 1, i: telling.size });
      });
    });
    const rij = [...telling.values()].sort((a, b) => b.n - a.n || a.i - b.i);
    const pagina = cfg.collectie && geldig(cfg.collectie) ? netjes(cfg.collectie) : null;
    if (pagina) {
      const hier = rij.findIndex((x) => x.c.id && x.c.id === pagina.id);
      if (hier > 0 && rij[hier].n === rij[0].n) rij.unshift(rij.splice(hier, 1)[0]);
      else if (hier === -1) rij.push({ c: pagina, n: 0, i: rij.length });
    }
    return rij;
  }

  /* ---------- Het venster ---------- */

  let venster = null;
  let terug = null;
  let buitenGedrukt = false;
  let bezig = false;
  // Wat het venster nu toont: de collecties die de vergelijker mocht proberen, de actieve collectie en hoeveel
  // producten er vooraf stil uit de keuze gingen.
  let huidig = null;

  const deel = (sel) => venster.querySelector(sel);

  function toonMelding(tekst) {
    const el = deel('.ap-vgm__melding');
    el.textContent = tekst;
    el.hidden = !tekst;
  }

  // Kan de focus hier blijven of heen? Niet de body, niet iets onzichtbaars en niet iets in de gesloten lade
  // (die krijgt aria-hidden). Op de telefoon lukt het de lade niet om de focus terug te zetten (de knop is dan
  // nog verborgen), en <dialog> zet hem na sluiten terug op het element van daarvoor.
  const bruikbaar = (el) => Boolean(el && el.isConnected && el !== document.body && el.getClientRects().length &&
    !el.closest('[aria-hidden="true"]') && window.getComputedStyle(el).visibility !== 'hidden');

  function opGesloten() {
    document.documentElement.classList.remove('ap-vgm-open');
    huidig = null;
    const vg = venster.querySelector('ap-vergelijker');
    if (vg) vg.remove();
    // Focus terug naar waar hij was, anders naar de knop Vergelijken van de lade.
    const kandidaten = [terug, ladeKnop()];
    terug = null;
    const actief = document.activeElement;
    if (bruikbaar(actief) && !venster.contains(actief)) return;
    const doel = kandidaten.find(bruikbaar);
    if (doel) {
      try {
        doel.focus({ preventScroll: true });
      } catch (e) {
        /* niet focusbaar */
      }
    }
  }

  function bouw() {
    const d = document.createElement('dialog');
    d.className = 'ap-vgm';
    d.setAttribute('aria-labelledby', 'ap-vgm-titel');
    d.innerHTML = `
      <div class="ap-vgm__venster" data-ap-vg-balkouder>
        <div class="ap-vgm__kop">
          <div class="ap-vgm__koptekst">
            <h2 class="ap-vgm__titel" id="ap-vgm-titel">${esc(t('modal_kop'))}</h2>
            <p class="ap-vgm__sub" hidden></p>
          </div>
          <button type="button" class="ap-vgm__sluit" data-ap-vgm-sluit aria-label="${esc(t('sluiten'))}" title="${esc(t('sluiten'))}">${SLUIT_ICOON}</button>
        </div>
        <div class="ap-vgm__inhoud" data-ap-vg-scroll>
          <p class="ap-vgm__melding" role="status" hidden></p>
          <div class="ap-vgm__laden" role="status"><span class="ap-vgm__draai" aria-hidden="true"></span><span class="ap-vgm__laden-tekst"></span></div>
          <div class="ap-vgm__vergelijker"></div>
        </div>
      </div>`;
    document.body.appendChild(d);

    // Klik buiten het venster (op de achtergrond) sluit, maar alleen als de klik daar ook begon (niet na slepen).
    d.addEventListener('pointerdown', (e) => { buitenGedrukt = e.target === d; });
    d.addEventListener('click', (e) => {
      const buiten = e.target === d && buitenGedrukt;
      buitenGedrukt = false;
      if (buiten || (e.target.closest && e.target.closest('[data-ap-vgm-sluit]'))) d.close();
    });
    // Esc sluit het venster (standaard van <dialog>). Staat het kiespaneel of een uitleg open, dan sluit de
    // vergelijker eerst die (keydown met preventDefault), en blijft het venster open.
    d.addEventListener('close', opGesloten);

    d.addEventListener('ap-vg:klaar', (e) => {
      const detail = e.detail || {};
      deel('.ap-vgm__laden').hidden = true;
      const sub = deel('.ap-vgm__sub');
      sub.textContent = detail.titel || '';
      sub.hidden = !detail.titel;
      if (!huidig) return;
      const actief = huidig.collecties.find((c) => c.handle === detail.handle) || null;
      huidig.actief = actief;
      const ontbrekend = Array.isArray(detail.ontbrekend) ? detail.ontbrekend.map(String) : [];
      // Wat getoond wordt zit in de actieve collectie: onthouden voor wie nog geen kaart heeft.
      if (actief) {
        huidig.keuze.filter((id) => ontbrekend.indexOf(id) === -1 && !kaartVan(id) && !vinkjeVan(id))
          .forEach((id) => bewaarKaart(id, [actief], true));
      }
      // "Andere categorie" alleen als dat ook zo is; anders (verdwenen, zonder data of onbekend) neutraal.
      const anders = ontbrekend.length > 0 && ontbrekend.every((id) => {
        const c = collectiesVan(id);
        return c && c.length > 0 && !c.some((x) => x.handle === detail.handle);
      });
      const titel = detail.titel || '';
      if (huidig.weg || (ontbrekend.length && !anders)) toonMelding(t('niet_alle', { collectie: titel }));
      else if (ontbrekend.length) toonMelding(t('niet_mee', { collectie: titel }));
      if (ontbrekend.length) zetSelectie(selectie().filter((p) => ontbrekend.indexOf(p.id) === -1));
    });
    d.addEventListener('ap-vg:keuze', (e) => {
      const producten = e.detail && Array.isArray(e.detail.producten) ? e.detail.producten : [];
      if (producten.length < 2) return;
      const oud = new Map(selectie().map((p) => [p.id, p.url]));
      const nieuw = producten.map((p) => ({ id: String(p.id), url: oud.get(String(p.id)) || p.url || '' }));
      zetSelectie(nieuw);
      // Via Wijzig gekozen: zit in de collectie van het venster. Staat het vinkje op deze pagina, dan de kaart
      // daarvan; anders meteen een voorlopige kaart (zodat de regel van dezelfde categorie blijft gelden) en de
      // volledige kaart ophalen.
      const actief = huidig && huidig.actief;
      nieuw.filter((p) => !oud.has(p.id)).forEach((p) => {
        const cb = vinkjeVan(p.id);
        const lijst = cb ? uitVinkje(cb) : null;
        if (lijst) {
          bewaarKaart(p.id, lijst);
          return;
        }
        if (!moetOphalen(p)) return;
        if (actief && !kaartVan(p.id)) bewaarKaart(p.id, [actief], true);
        haalKaart(p);
      });
      if (huidig) huidig.keuze = nieuw.map((p) => p.id);
    });
    // Toch niets te vergelijken of het laden mislukte: geen leeg venster, maar sluiten met een korte melding.
    d.addEventListener('ap-vg:mislukt', (e) => {
      const fout = e.detail && e.detail.reden === 'fout';
      // Klopten de kaarten niet met de data van de collectie (intussen gewijzigd), dan de volgende keer opnieuw ophalen.
      if (!fout && huidig) vergeetKaarten(huidig.keuze);
      if (d.open) d.close();
      meldKort(fout ? t('laden_mislukt') : t('min_twee'), ladeKnop());
    });
    return d;
  }

  async function open() {
    if (bezig || (venster && venster.open)) return;
    bezig = true;
    try {
      await openNu();
    } finally {
      bezig = false;
      document.documentElement.classList.remove('ap-vgm-wacht');
    }
  }

  async function openNu() {
    const actiefVoor = document.activeElement;
    let sel = selectie();
    if (sel.length < 2) {
      meldKort(t('min_twee'), ladeKnop());
      return;
    }
    // Gekozen producten die we nog niet kennen eerst ophalen (meestal al gebeurd bij het laden van de pagina).
    if (sel.some(moetOphalen)) {
      document.documentElement.classList.add('ap-vgm-wacht');
      await Promise.race([leerKennen(sel), wacht(OPHALEN_MS)]);
    }
    const weg = ruimOp();
    sel = selectie();
    if (sel.length < 2) {
      meldKort(t('min_twee'), ladeKnop());
      return;
    }
    const onbekend = sel.filter((p) => !collectiesVan(p.id)).length;
    const kans = telCollecties(sel).filter((x) => x.n + onbekend >= 2);
    if (!kans.length) {
      // Alles bekend en geen 2 producten uit dezelfde categorie (een oude, gemengde keuze): opnieuw kiezen.
      if (!onbekend) {
        zetSelectie([]);
        meldKort(t('gemengd'), ladeKnop());
      } else {
        meldKort(t('min_twee'), ladeKnop());
      }
      return;
    }
    if (!venster) venster = bouw();
    if (venster.open) return;
    const collecties = kans.map((x) => x.c);
    huidig = { collecties, actief: null, keuze: sel.map((p) => p.id), weg };

    terug = bruikbaar(actiefVoor) ? actiefVoor : null;
    toonMelding('');
    const sub = deel('.ap-vgm__sub');
    sub.textContent = '';
    sub.hidden = true;
    deel('.ap-vgm__laden-tekst').textContent = t('laden');
    deel('.ap-vgm__laden').hidden = false;

    document.documentElement.classList.remove('ap-vgm-wacht');
    document.documentElement.classList.add('ap-vgm-open');
    venster.showModal();
    deel('.ap-vgm__inhoud').scrollTop = 0;

    // Tot het volledige script er is, blijft de laadstand staan. Is het venster intussen gesloten (of opnieuw
    // geopend), dan niets doen.
    const dit = huidig;
    laadVolledig().then(() => {
      if (!venster.open || huidig !== dit) return;
      const vg = document.createElement('ap-vergelijker');
      vg.className = 'ap-vg';
      vg.setAttribute('data-modus', 'vrij');
      const conf = document.createElement('script');
      conf.type = 'application/json';
      conf.setAttribute('data-ap-vg-config', '');
      conf.textContent = JSON.stringify({
        v: 1,
        keuze: dit.keuze,
        taal: cfg.taal || document.documentElement.lang || 'nl',
        collecties,
        teksten
      });
      vg.appendChild(conf);
      deel('.ap-vgm__vergelijker').appendChild(vg);
    }, () => {
      if (!venster.open || huidig !== dit) return;
      deel('.ap-vgm__laden').hidden = true;
      toonMelding(t('laden_mislukt'));
    });
  }

  // Nu vergelijken (compare-drawer.js) stuurt dit event naar het oude venster; wij zijn eerder (capture op window).
  window.addEventListener('on:product-compare-modal:open', (e) => {
    e.stopImmediatePropagation();
    open();
  }, true);

  /* ---------- Bij het laden: kaarten bijwerken ---------- */

  // Gekozen producten met een vinkje op deze pagina: kaart bijwerken. De rest ophalen, en wat niet (meer) te
  // vergelijken is uit de keuze halen.
  (() => {
    const sel = selectie();
    if (!sel.length) return;
    sel.forEach((p) => {
      const cb = vinkjeVan(p.id);
      const lijst = cb ? uitVinkje(cb) : null;
      if (lijst) bewaarKaart(p.id, lijst);
    });
    if (sel.some(moetOphalen)) leerKennen(sel).then(ruimOp, () => {});
    else ruimOp();
  })();

  /* ---------- Geen enkel vinkje op de pagina ---------- */

  // Een collectie (of zoekresultaat of filter) zonder producten met vergelijkdata: de schakelaar Vergelijken in de
  // werkbalk doet dan niets. Die verbergen we, en het raster krijgt data-compare="false" zoals met vergelijken uit
  // (products-toolbar.js), zonder die stand te bewaren. Komen er door filteren of verder laden wel vinkjes, dan
  // weer de stand van de schakelaar.
  const raster = document.querySelector('.main-products-grid');
  if (raster && 'MutationObserver' in window) {
    let gepland = 0;
    const pasAan = () => {
      gepland = 0;
      const vinkjes = Boolean(raster.querySelector('.js-compare-checkbox'));
      const schakel = document.querySelector('.products-toolbar__compare');
      if (schakel) schakel.style.display = vinkjes ? '' : 'none';
      const knop = document.getElementById('compare-switch');
      const stand = vinkjes ? String(knop ? knop.checked : true) : 'false';
      if (raster.dataset.compare !== stand) raster.dataset.compare = stand;
    };
    const plan = () => {
      if (!gepland) gepland = requestAnimationFrame(pasAan);
    };
    new MutationObserver(plan).observe(raster, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-compare'] });
    pasAan();
  }

  /* ---------- Het volledige script op tijd laden ---------- */

  const VERGELIJK_DELEN = '.card__compare, .js-compare-checkbox, .products-toolbar__compare, #compare-switch, #compare-drawer-open, compare-drawer';
  const opAanraking = (e) => {
    const el = e.target;
    if (!el || !el.closest || !el.closest(VERGELIJK_DELEN)) return;
    ['pointerdown', 'focusin', 'change'].forEach((type) => window.removeEventListener(type, opAanraking, true));
    laadVolledig().catch(() => {});
  };
  ['pointerdown', 'focusin', 'change'].forEach((type) => window.addEventListener(type, opAanraking, true));
  if (selectie().length) {
    const straks = () => {
      const doe = () => { laadVolledig().catch(() => {}); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(doe, { timeout: 3000 });
      else setTimeout(doe, 1);
    };
    if (document.readyState === 'complete') straks();
    else window.addEventListener('load', straks, { once: true });
  }

  // Als laatste: het teken dat alles klaarstaat (het vangnet in snippets/astools-vergelijk-lijst.liquid kijkt hiernaar).
  window.apVergelijkVenster = { open };
})();
